// Core Imports
import GraniteError from 'granite-admin/utils/granite-error';
import GraniteAPIClient from 'granite-admin/utils/granite-client';
import AuditEntity from 'granite-admin/common/entities/audit';
async function getAudits(params) {
  const payload = {
    params: {
      ...params
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient().get('/audits/', payload);
    const auditList = data ? data.results.map(item => new AuditEntity(item)) : [];
    return {
      list: auditList,
      count: data.count
    };
  } catch (error) {
    throw new GraniteError(error);
  }
}
export { getAudits };